import { render, staticRenderFns } from "./ExternalForm.vue?vue&type=template&id=36f43635&"
import script from "./ExternalForm.vue?vue&type=script&lang=js&"
export * from "./ExternalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports